import React from 'react';

const inputFocus =
  'focus:ring-2 focus:ring-prodia-primary/30 focus:border-prodia-primary focus:outline-none';

export function SalesProgressFiltersGrid({ children }) {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>;
}

export function SalesProgressFilterField({ icon, label, children }) {
  return (
    <div>
      <label className="block text-sm font-medium text-prodia-text-secondary mb-2">
        <i className={`fas ${icon} mr-2`} aria-hidden="true"></i>
        {label}
      </label>
      {children}
    </div>
  );
}

export function PersonFilterSelect({ value, onChange, options, allLabel, className = '' }) {
  return (
    <select
      value={value}
      onChange={onChange}
      className={`w-full px-4 py-3 border border-prodia-border rounded-xl bg-prodia-surface text-sm ${inputFocus} ${className}`}
    >
      <option value="all">{allLabel}</option>
      {options.map((name) => (
        <option key={name} value={name}>
          {name}
        </option>
      ))}
    </select>
  );
}
